<template>
  <div class="main-container">
    <div class="bread">
      <ExamIndexBread></ExamIndexBread>
      <span class="slash">/</span>
      <router-link :to="{ name: 'ExamPackage' }">套卷练习</router-link>
      <span class="slash">/</span>
      <router-link
        :to="{ name: 'ExamPackagePaper', query: { id: package_id } }"
      >
        {{ package_name }}
      </router-link>
      <span class="slash">/</span>
      <span class="current">{{ scantron.title }}</span>
    </div>
    <div class="main-content clearfix">
      <div class="f-left">
        <template v-if="current">
          <el-scrollbar v-if="hasScroll" style="height: calc(100vh - 148px)">
            <div class="paper-title">{{ scantron.title }}</div>
            <template
              v-if="
                section[current.question_id] && scantron.data.length > 1
              "
            >
              <div class="section-name">
                {{ section[current.question_id].name }}
              </div>
              <div class="section-introduce">
                {{ section[current.question_id].introduce }}
              </div>
            </template>
            <Question
              :isFile="1"
              :ques="current"
              :answer="answer"
              shotAnswerEditable
              showOperate
              :answerImg="answerImg"
              @addImg="addImg"
              @deleteImg="deleteImg"
              :reportId="id"
              @change="onChange(current)"
              :readonly="
                this.$store.state.questionModeSelect == 2 &&
                current.is_confirm == 1
              "
              :hasAnalysis="
                this.$store.state.questionModeSelect == 2 &&
                current.is_confirm == 1
              "
              :showAnalysisBtn="false"
              :showAnswerBtn="true"
            ></Question>
          </el-scrollbar>
          <div class="back-white" v-else>
            <div class="paper-title">{{ scantron.title }}</div>
            <template
              v-if="
                section[current.question_id] && this.scantron.data.length > 1
              "
            >
              <div class="section-name">
                {{ section[current.question_id].name }}
              </div>
              <div class="section-introduce">
                {{ section[current.question_id].introduce }}
              </div>
            </template>
            <Question
              :isFile="20"
              :ques="current"
              :answer="answer"
              :readonly="
                this.$store.state.questionModeSelect == 2 &&
                current.is_confirm == 1
              "
              :hasAnalysis="
                this.$store.state.questionModeSelect == 2 &&
                current.is_confirm == 1
              "
              :showAnalysisBtn="false"
              :showAnswerBtn="true"
              shotAnswerEditable
              showOperate
              :answerImg="answerImg"
              @addImg="addImg"
              @deleteImg="deleteImg"
              :reportId="id"
              @change="onChange(current)"
            ></Question>
          </div>
        </template>
      </div>
      <div ref="rightWrap" class="f-right" :style="style">
        <ExamDoRight
          ref="right"
          :reportId="id"
          :scantron="scantron"
          :answer="answer"
          :answerImg="answerImg"
          :limitTime="paper.limit_time"
          hasSection
          shotAnswerEditable
          @topicChange="onTopicChange"
          @submit="submit"
        ></ExamDoRight>
      </div>
    </div>
  </div>
</template>
<script>
import Question from "@/components/ques/Question.vue";
import ExamDoRight from "./components/ExamDoRight.vue";
import ExamIndexBread from "./components/ExamIndexBread.vue";

export default {
  name: "ExamPackageDo",
  components: {
    Question,
    ExamDoRight,
    ExamIndexBread,
  },
  data() {
    return {
      id: this.$route.query.id,
      package_id: this.$route.query.package_id,
      package_name: this.$route.query.package_name,
      paper_id: this.$route.query.paper_id,
      answer: {},
      current: {},
      storeKey: "exam-seconds",
      scantron: {},
      answerImg: {},
      section: {},
      paper: {},
      scantronQuestions: [],
      index: 1,
      hasScroll: false,
      fixed: 0,
      fixedRight: 0,
    };
  },
  computed: {
    style() {
      let style = {};
      style.right = this.fixedRight + "px";
      if (this.fixed == 1) {
        style.position = "fixed";
        style.top = "70px";
      } else if (this.fixed == 2) {
        style.position = "absolute";
        style.bottom = "0";
      }
      return style;
    },
  },
  watch: {
    "current.is_sign": {
      handler() {
        this.scantronQuestions.find(
          q => q.question_id == this.current.question_id,
        ).is_sign = this.current.is_sign;
      },
    },
    current() {
      this.initScroll();
    },
  },
  async created() {
    this.paper = await this.$http.post("/api/app/practice/exam", {
      package_id: this.package_id,
      exam_id: this.paper_id,
      report_id: this.id,
    });
    await this.getTopicStatus();
    this.$nextTick(() => {
      this.$refs.right.init(this.index);
    });
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener("scroll", this.setFixed);
      document.addEventListener("resize", this.setFixed);
    });
  },
  destroyed() {
    document.removeEventListener("scroll", this.setFixed);
    document.removeEventListener("resize", this.setFixed);
  },
  methods: {
    setFixed() {
      let $ = window.$;
      let scrollTop = $(document.documentElement).scrollTop();
      if (scrollTop > 48) {
        let footerOffset = $("#footerBar").offset();
        let rightHeight = this.$refs.rightWrap.clientHeight;
        if (footerOffset.top - rightHeight - scrollTop < 100) {
          this.fixed = 2;
          this.fixedRight = 0;
        } else {
          this.fixed = 1;
          this.fixedRight = ($(window).width() - 1200) / 2;
          if (this.fixedRight < 0) {
            this.fixedRight = 0;
          }
        }
      } else {
        this.fixed = 0;
      }
    },
    async getTopicStatus() {
      let data = await this.$http.post("/api/app/practice/scantron", {
        report_id: this.id,
        type: 2,
      });
      let list = [];
      data.data.forEach(t => {
        t.child.forEach((ques, index) => {
          list.push(ques);
          if (index == 0) {
            this.$set(this.section, ques.question_id, {
              name: t.name,
              introduce: t.introduce,
            });
          }
        });
      });
      let answerCount = list.filter(t => t.status == 1 || t.status == 2).length;
      if (answerCount > 0) {
        let quesFirst = list.find(q => q.status == 3);
        if (quesFirst) {
          this.index = quesFirst.sort;
        }
      }
      this.scantron = data;
      this.scantronQuestions = list;
      // 全部模式
      this.$store.commit("setQuestionMode", data.practise_module);
      // 当前模式
      this.$store.commit("setQuestionModeSelect", data.mode);
    },
    addImg(ques, path) {
      let images = this.answerImg[ques.question_id] || [];
      images.push(path);
      this.$set(this.answerImg, ques.question_id, images);
    },
    deleteImg(ques, index) {
      this.answerImg[ques.question_id].splice(index, 1);
    },
    onTopicChange(ques) {
      this.hasScroll = false;
      this.scantronQuestions.find(
        q => q.question_id == ques.question_id,
      ).status = ques.status;
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        this.$set(this.answer, ques.question_id, ques.user_answer);
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        this.$set(
          this.answer,
          ques.question_id,
          ques.user_answer
            ? ques.user_answer.split(",").map(s => Number(s))
            : [],
        );
      } else if (ques.ques_type == 7) {
        this.$set(
          this.answer,
          ques.question_id,
          ques.user_answer
            ? ques.user_answer.split("@@")
            : ques.right_answer.map(() => ""),
        );
      } else if (ques.ques_type == 5) {
        //简答题
        if (ques.user_answer) {
          let user_answer = JSON.parse(ques.user_answer);
          this.$set(this.answer, ques.question_id, user_answer.content);
          this.$set(this.answerImg, ques.question_id, user_answer.images);
        }
      }
      this.$set(this, "current", ques);
    },
    onChange(ques) {
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        if (this.answer[ques.question_id]) {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 1;

          // examDoRight.vue内部监听状态进行练习模式出答案
          if (this.$store.state.questionModeSelect == 2 && !ques.is_confirm) {
            this.$store.commit("setShowQuestionAnswer", {
              is_confirm: 1,
              get: true,
            });
          } else {
            this.$refs.right.navNext();
          }
        }
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        if (this.answer[ques.question_id].length > 0) {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 1;
        } else {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 3;
        }
      } else if (ques.ques_type == 7) {
        if (this.answer[ques.question_id].some(Boolean)) {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 1;
        } else {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 3;
        }
      } else if (ques.ques_type == 5) {
        //简答题
        if (
          this.answer[ques.question_id] ||
          (this.answerImg[ques.question_id] || []).length > 0
        ) {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 1;
        } else {
          this.scantronQuestions.find(
            q => q.question_id == ques.question_id,
          ).status = 3;
        }
      }
    },
    submit() {
      this.$router.replace({
        name: "ExamPackageReport",
        query: {
          id: this.$route.query.id,
          package_id: this.package_id,
          package_name: this.package_name,
          paper_id: this.paper_id,
        },
      });
    },
    initScroll() {
      this.$nextTick(() => {
        setTimeout(() => {
          let height = this.$pub.getScreenHeight();

          if (document.body.clientHeight > height + 148) {
            this.hasScroll = true;
          } else {
            this.hasScroll = false;
          }
        }, 0);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  overflow: hidden;
}
.main-content {
  margin-bottom: 30px;
  position: relative;
  > .f-left {
    width: 890px;
    border-radius: 5px;

    .back-white {
      background-color: white;
    }

    /deep/ {
      .el-scrollbar__wrap {
        border-radius: 5px;
      }
      .el-scrollbar__view {
        background-color: white;
        border-radius: 5px;
      }
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      .el-scrollbar__thumb {
        background-color: #bfbfbf;
      }
    }
  }
  > .f-right {
    width: 290px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    padding: 19px 20px;
    box-sizing: border-box;
  }
}
.paper-title {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333;
  line-height: 1;
  text-align: center;
  padding-top: 29px;
}
.section-name {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 1;
  padding: 21px 0 0 32px;
}
.section-introduce {
  font-size: 14px;
  color: rgba(128, 128, 128, 1);
  line-height: 1;
  padding: 20px 0 0 32px;
}
</style>
